import React, { Component } from "react";

import HomePage from "./pages/homepage";
import WorkPage from "./pages/workpage";
import ArtPage from "./pages/artpage";
import CocktailPage from "./pages/cocktailpage";
import NotFoundPage from "./pages/notfoundpage";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import NavBar from "./components/navbar";
import "./App.css";

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <NavBar />
          <div id="page-body">
            <Switch>
              <Route path="/" component={HomePage} exact />
              <Route path="/art" component={ArtPage} exact />
              <Route path="/work" component={WorkPage} exact />
              <Route path="/cocktails" component={CocktailPage} exact />
              <Route component={NotFoundPage} />
            </Switch>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
